import styled from "styled-components";

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 20px;

  h2 {
    font-size: 6em;
    font-weight: 900;
    color: var(--color-error);
    letter-spacing: 6px;
    line-height: 1;

    @media (max-width: 600px) {
      font-size: 4em; /* Smaller font for tablets and smaller screens */
    }
  }

  p {
    color: var(--color-error);
    font-weight: 700;
    margin: 0;
    letter-spacing: 1px;
  }
`;